const getLastRefresh = (store) => {
  return store.lastRefresh;
};

export { getLastRefresh };
